export default __webpack_public_path__ + "static/media/baron-von-binance.f75414f0.png";